export default __webpack_public_path__ + "static/favicon-fbcf245208174d811075922be3499c14.ico";